import React from 'react';
import '../WebflowCss/ark-payment.webflow.css';
import WomandDesk from '../assets/images/icon-desk-woman.svg';
import { RoundButton } from './Common';

export const ConsultantSection = () => {
  return (
    <div className="consultant-section">
      <div className="presenter-container">
        <div className="split-container">
          <div className="shadow-con-left">
            <div className="text-block-40">
              Still not sure?
              <br />
              Get a call from a online consultant!
            </div>
            <div className="text-block-25">
              We make the transition even easier with real human help
              <br />
              by our online consultants.
            </div>
            <RoundButton text="Request a call-back now!" className="white" onClick />
          </div>
          <div className="image-container-consultant">
            <img src={WomandDesk} loading="lazy" height="" alt="" className="box-image-right" />
            <div className="circle"></div>
          </div>
        </div>
      </div>
    </div>
  );
};
